import { Check } from './icons';

/** Compact numbered steps with a connecting rail; current step is announced via aria-current. */
export function StepIndicator({
  steps,
  current,
  label,
}: {
  steps: readonly string[];
  current: number;
  label: string;
}) {
  return (
    <ol aria-label={label} className="flex items-center gap-2">
      {steps.map((title, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li
            key={title}
            className="flex items-center gap-2"
            aria-current={active ? 'step' : undefined}
          >
            <span
              className={[
                'tabular flex size-7 items-center justify-center rounded-full text-xs font-semibold',
                done
                  ? 'bg-brand text-on-brand'
                  : active
                    ? 'border-2 border-brand text-brand'
                    : 'border border-line-strong text-ink-3',
              ].join(' ')}
              aria-hidden
            >
              {done ? <Check size={14} /> : i + 1}
            </span>
            <span className={['text-sm', active ? 'font-medium text-ink' : 'text-ink-2'].join(' ')}>
              {title}
            </span>
            {i < steps.length - 1 ? (
              <span aria-hidden className="mx-1 h-px w-6 bg-line-strong" />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
